import { z } from 'zod';
export const StartCaptureQueryRequestSchema = z.object({
    m: z.string(),
});
export const StartCaptureRequestSchema = StartCaptureQueryRequestSchema;
